<script>
export default {
  computed: {
    baseUrl() {
      return 'https://adhocstudio.ca/dev/NewProjectDataManagement/projectManager/';
    }
  },
  methods: {
    numBedsByType(type) {
      switch (type) {
        case 'studio': { return 0; }
        case 'one':
        case 'oneDen': { return 1; }
        case 'two':
        case 'twoDen': { return 2; }
        case 'three':
        case 'threeDen': { return 3; }
        default: { return 0; }
      }
    },
    directionBySlug(dir) {
      switch (dir) {
        case 'n': { return 'North'; }
        case 'e': { return 'East'; }
        case 's': { return 'South'; }
        case 'w': { return 'West'; }
        default: { return false; }
      }
    },
    typeLabelConv(shortType) {
      // switch (shortType) {
      //   case 'one': { return '1 Bedroom'; }
      //   case 'oneDen': { return '1 Bedroom + Den'; }
      //   case 'two': { return '2 Bedroom'; }
      //   case 'twoDen': { return '2 Bedroom + Den'; }
      //   case 'three': { return '3 Bedroom'; }
      //   case 'threeDen': { return '3 Bedroom + Den'; }
      //   default: { return 'Studio'; }
      // }
      switch (shortType) {
        case 'one': { return '1B'; }
        case 'oneDen': { return '1B+D'; }
        case 'two': { return '2B'; }
        case 'twoDen': { return '2B+D'; }
        case 'three': { return '3B'; }
        case 'threeDen': { return '3B+D'; }
        default: { return 'Studio'; }
      }
    },
    convertToUnitySuite(inUnit) {
      let floor = inUnit.floor;
      let suite = inUnit.suite;
      if (floor.length === 1) {
        floor = `0${floor}`;
      }
      if (suite.length === 1) {
        suite = `0${suite}`;
      }
      return floor + suite;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/FloorplansPage/FloorplanMixin.vue